<template>
<span>
  <span v-if="!errorMsg">{{ userNameFromStore }}</span>
  <span v-else class="lighter">{{ errorMsg }}</span>
</span>
</template>

<script>
import isUUID from "is-uuid";
import { mapState } from "vuex";
export default {
  name: "UserNameDisplay",
  props: {
    userId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      errorMsg: '',
      listName: 'UserDisplayList'
    }
  },
  computed: {
    ...mapState({
      users: state => state.users.usersLists
    }),
    userNameFromStore() {
      if(!this.userId) {
        return '-';
      }
      if(!this.$store.getters.isSuperAdmin && (this.$store.getters.idIsSFXMember(this.userId) || this.$store.getters.idIsSuperAdmin(this.userId))) {
        return 'vHUB Admin';
      }
      if(this.$store.getters.getCurrentUserId && this.$store.getters.getCurrentUserId === this.userId) {
        return this.$t('me');
      }
      if (isUUID.v4(this.userId)) {
        let user = this.userFromStore;
        if(user) {
          return user.name;
        }
      }
      return this.userId;
    },
    userFromStore() {
      if (isUUID.v4(this.userId)) {
        const list = this.users[this.listName];
        if(list && list[this.userId]) {
          return list[this.userId];
        }
      }
      return null;
    }
  },
  watch: {
    userId() {
      this.loadUserById();
    }
  },
  beforeMount() {
    this.loadUserById();
  },
  methods: {
    async loadUserById() {
      this.errorMsg = '';
      if (isUUID.v4(this.userId)) {
        if(!this.userFromStore) {
          await this.$store.dispatch('loadUsers', {
            listName: this.listName,
            keep: {
              limit: 0
            },
            doNotSendTwice: true
          });
        }
      }
    }
  }
}
</script>